export enum UserRoles {
    ADMIN = 'Admin',
    Patron = 'Patron',
    PatronLight = 'PatronLight',
    Participant = 'Participant',
}

export const patronRoles = [UserRoles.Patron, UserRoles.PatronLight, UserRoles.ADMIN];